import { render, staticRenderFns } from "./ListHeadersModifier.vue?vue&type=template&id=79fc5f4e&"
import script from "./ListHeadersModifier.vue?vue&type=script&lang=js&"
export * from "./ListHeadersModifier.vue?vue&type=script&lang=js&"
import style0 from "./ListHeadersModifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCheckbox,VList,VListItemGroup})
